import { createApp } from "vue";
import MapMovement from '@/pages/MapMovement.vue';

function attachVueApp(App) {
    const app = createApp(App, {
        holding_id: $('#map').data('holding-id'),
        company_id: $('#map').data('company-id'),
        section_id: $('#map').data('section-id'),
    });
    app.provide('url_save_request_video_data', $('#map').data('url-save-request-video-data'));
    return app.mount('#map');
}

if (is_route('movement.index')) {
    attachVueApp(MapMovement);
}
